/**
 * Register Professor Claim Wizard Alpine Component
 */
import professorClaimWizard from './wizard.js';

function registerComponent() {
    window.Alpine.data('professorClaimWizard', professorClaimWizard);
}

if (window.Alpine) {
    registerComponent();
} else {
    document.addEventListener('alpine:init', registerComponent);
    document.addEventListener('livewire:init', registerComponent);
}

export default professorClaimWizard;

